'use strict';

/*------------------------------------*\
 * JS Main entry file
 \*------------------------------------*/
import './config';

// // Import utilities.
// import '@utilities/in-view';
import '@utilities/noisegrid';

// // Import Singletons
import '@utilities/detect-touch';
import 'lazysizes';

// noiseGrid();



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/EXT/snaders/frontend/source/javascript/main.js